import type { IOrganizationFeatureIdSmart } from './OrganizationFeatureIdSmart.interface';

export default class OrganizationFeatureIdSmart implements IOrganizationFeatureIdSmart {
  idSmartRemaining: number;
  automaticallyRecharge: boolean;
  rechargeWhenIdSmartRemainingReach: number;

  static build = (data: IOrganizationFeatureIdSmart) => new OrganizationFeatureIdSmart(data);

  static blank = () => new OrganizationFeatureIdSmart();

  /**
   * Constructor
   * @param {IOrganizationFeatureIdSmart} data
   */
  constructor(data?: IOrganizationFeatureIdSmart) {
    this.idSmartRemaining = parseInt(data?.idSmartRemaining || 0, 10);
    this.automaticallyRecharge = data?.automaticallyRecharge === true;
    this.rechargeWhenIdSmartRemainingReach = parseInt(
      data?.rechargeWhenIdSmartRemainingReach || 0,
      10
    );
  }
}
